import { adminUsersApi } from 'entities/adminUser/api/adminUsersApi';
import { makeAutoObservable, runInAction } from 'mobx';
import { Role } from 'app/store/lib/authStore';

export type AdminUserData = {
  id: string;
  name: string;
  surname: string;
  email: string;
  role: Role;
};

export class AdminUserModel {
  public isPending = false;
  public isError = false;

  private _data: AdminUserData;

  public get id() {
    return this._data.id;
  }
  public get name() {
    return `${this._data.name} ${this._data.surname}`;
  }
  public get email() {
    return this._data.email;
  }
  public get role() {
    return this._data.role;
  }

  constructor(data: AdminUserData) {
    this._data = data;
    makeAutoObservable(this);
  }

  public async setRole(role: Role) {
    runInAction(() => {
      this.isPending = true;
      this.isError = false;
    });

    try {
      await adminUsersApi.update({ ...this._data, role });
      this._data.role = role;
    } catch (e) {
      runInAction(() => {
        this.isPending = false;
        this.isError = true;
      });
      throw e;
    }
  }

  public async delete() {
    runInAction(() => {
      this.isPending = true;
      this.isError = false;
    });

    try {
      await adminUsersApi.delete(this.id);
    } catch (e) {
      runInAction(() => {
        this.isPending = false;
        this.isError = true;
      });
      throw e;
    }
  }
}
